import { jsxs, jsx } from "react/jsx-runtime";
import Button from "../../../../../buttons/Button/Button.js";
import IconButton from "../../../../../buttons/IconButton/IconButton.js";
import Icon from "../../../../../graphics/Icon/Icon.js";
import Group from "../../../../../layout/Group/Group.js";
import Link from "../../../../../navigation/Link/Link.js";
import { L as LocalNavbarStyles } from "../../../../../../LocalNavbar.module-D_uZkV8K.js";
import { useTracking } from "../../../../../../hooks/useTracking.js";
import Brand from "../../../../../graphics/Brand/Brand.js";
import "../../../../../graphics/Brand/items/IdaLogo.js";
import "../../../../../graphics/Brand/items/MitIdaLogo.js";
import "../../../../../graphics/Brand/items/IdaForsikringLogo.js";
const MobileNavbar = (props) => {
  const { register, search, links, logo, openMenu, isMenuOpen, hiddenFrom, ...rest } = props;
  const tracker = useTracking();
  delete rest.actionLink;
  return /* @__PURE__ */ jsxs(
    Group,
    {
      align: "center",
      justify: "space-between",
      className: LocalNavbarStyles.innerWrapper,
      hiddenFrom,
      wrap: "nowrap",
      children: [
        isMenuOpen && register ? /* @__PURE__ */ jsx(
          Button,
          {
            variant: "cta",
            compact: true,
            hiddenFrom: "lg",
            text: register == null ? void 0 : register.text,
            href: register == null ? void 0 : register.href,
            onClick: () => tracker == null ? void 0 : tracker.page.navigate({
              type: "header",
              action: register == null ? void 0 : register.text,
              destination: register == null ? void 0 : register.href
            })
          }
        ) : /* @__PURE__ */ jsx(
          Brand,
          {
            name: (logo == null ? void 0 : logo.icon) || "IdaLogo",
            variant: "light",
            href: (logo == null ? void 0 : logo.href) || "/",
            target: logo == null ? void 0 : logo.target,
            width: "auto",
            height: 27
          }
        ),
        /* @__PURE__ */ jsxs(Group, { align: "center", spacing: "md", className: LocalNavbarStyles.right, children: [
          search && isMenuOpen && /* @__PURE__ */ jsx(Link, { target: search.target, href: search.href, className: LocalNavbarStyles.search, children: /* @__PURE__ */ jsx(Icon, { name: "Search", size: "sm", color: "light" }) }),
          links && (isMenuOpen ? /* @__PURE__ */ jsx(
            IconButton,
            {
              onClick: () => openMenu == null ? void 0 : openMenu(false),
              size: "md",
              icon: "X",
              className: LocalNavbarStyles.burger,
              "aria-label": "Luk mobil-menu"
            }
          ) : /* @__PURE__ */ jsx(
            IconButton,
            {
              variant: "whiteAndColor",
              onClick: () => openMenu == null ? void 0 : openMenu(true),
              hiddenFrom: "lg",
              size: "md",
              icon: "Menu2",
              className: LocalNavbarStyles.burger,
              "aria-label": "Åben mobil-menu"
            }
          ))
        ] })
      ]
    }
  );
};
export {
  MobileNavbar as default
};
